import React from "react";

export default function ProphetMuhammadFrame2({ frameTextToggle, children }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2000 2000"
      width="300"
      height="300"
      fill="none"
    >
      <g transform={frameTextToggle}>
        <defs>
          <style>{".cls-prop21{fill:#efd050}.cls-prop23{fill:#e0bf36}"}</style>
        </defs>
        <path
          d="M1480.36 794.71c-12.96-.34-25.91-.69-38.88-1.03-1.34-16.56-13.1-146.08-81.78-219.5-23.42-25.04-51.03-43.21-51.03-43.21-36.81-24.26-70.92-34.15-89.35-38.41-1.47-21.43-5.96-53.36-20.87-87.49-25.37-58.12-64.9-85.88-90.7-110.18-36.79-34.66-81.55-96.13-107.76-213.02-26.2 116.89-70.97 178.36-107.76 213.02-25.8 24.3-65.33 52.06-90.7 110.18-14.91 34.13-19.39 66.07-20.87 87.49-18.43 4.26-52.54 14.15-89.36 38.41-16.69 11.08-34.26 25.18-51.02 43.21-73.47 78.96-81.45 179.08-82.3 219.5-12.79.34-25.58.69-38.37 1.03-38.88 1.03-69.86 33.07-69.86 72.24v978.91c0 39.92 32.13 72.27 71.75 72.27h956.97c39.62 0 71.75-32.36 71.75-72.27V866.97c0-39.18-30.99-71.22-69.87-72.25Zm-29.38 923.84c0 44.92-36.42 81.34-81.34 81.34h-739.3c-44.92 0-81.34-36.42-81.34-81.34v-739.3c0-44.92 36.42-81.34 81.34-81.34h739.3c44.92 0 81.34 36.42 81.34 81.34v739.3Z"
          className="cls-prop23"
        />
        <path
          d="m1456.11 820.36-36.81-.97c-1.27-15.57-12.41-137.33-77.43-206.34-22.17-23.54-48.31-40.61-48.31-40.62-34.86-22.81-67.16-32.1-84.6-36.11-1.4-20.15-5.65-50.16-19.76-82.25-24.02-54.64-61.46-80.73-85.87-103.58-34.84-32.59-77.22-90.38-102.03-200.26-24.81 109.88-67.2 167.68-102.03 200.26-24.43 22.85-61.85 48.95-85.88 103.58-14.1 32.09-18.34 62.1-19.74 82.25-17.44 4.01-49.75 13.3-84.61 36.11-15.81 10.41-32.44 23.68-48.31 40.62-69.56 74.22-77.11 168.35-77.92 206.34-12.1.32-24.22.64-36.32.97-36.81.97-66.15 31.09-66.15 67.91v920.25c0 37.53 30.42 67.94 67.93 67.94h906.05c37.53 0 67.94-30.42 67.94-67.94V888.28c0-36.83-29.35-66.96-66.16-67.92Zm-5.13 898.19c0 44.92-36.42 81.34-81.34 81.34h-739.3c-44.92 0-81.34-36.42-81.34-81.34v-739.3c0-44.92 36.42-81.34 81.34-81.34h739.3c44.92 0 81.34 36.42 81.34 81.34v739.3Z"
          style={{
            fill: "#391f4c",
          }}
        />
        <path
          d="m793.13 599.14 21.5 43.56 48.07 6.98-34.79 33.91 8.22 47.88-43-22.6-43 22.6 8.21-47.88-34.79-33.91 48.08-6.98 21.5-43.56z"
          className="cls-prop23"
        />
        <path
          d="m793.13 665.3-21.5-22.6 21.5-43.56v66.16zM862.7 649.68l-69.57 15.62 21.5-22.6 48.07 6.98zM836.13 731.47l-43-66.17 34.78 18.29 8.22 47.88zM750.13 731.47l43-66.17v43.57l-43 22.6zM723.55 649.68l69.58 15.62-34.79 18.29-34.79-33.91z"
          className="cls-prop21"
        />
        <path
          d="m1188.92 566.72 13.72 27.8 30.68 4.46-22.2 21.64 5.24 30.56-27.44-14.43-27.45 14.43 5.24-30.56-22.2-21.64 30.68-4.46 13.73-27.8z"
          className="cls-prop23"
        />
        <path
          d="m1188.92 608.95-13.73-14.43 13.73-27.8v42.23z"
          className="cls-prop21"
        />
        <path
          d="m1233.32 598.98-44.4 9.97 13.72-14.43 30.68 4.46z"
          className="cls-prop21"
        />
        <path
          d="m1216.36 651.18-27.44-42.23 22.2 11.67 5.24 30.56z"
          className="cls-prop21"
        />
        <path
          d="m1161.47 651.18 27.45-42.23v27.8l-27.45 14.43z"
          className="cls-prop21"
        />
        <path
          d="m1144.51 598.98 44.41 9.97-22.21 11.67-22.2-21.64z"
          className="cls-prop21"
        />
        <path
          d="m963.21 381.87 13.72 27.8 30.68 4.46-22.2 21.64 5.24 30.55-27.44-14.42-27.44 14.42 5.24-30.55-22.2-21.64 30.68-4.46 13.72-27.8z"
          className="cls-prop23"
        />
        <path
          d="m963.21 424.1-13.72-14.43 13.72-27.8v42.23zM1007.61 414.13l-44.4 9.97 13.72-14.43 30.68 4.46zM990.65 466.32l-27.44-42.22 22.2 11.67 5.24 30.55z"
          className="cls-prop21"
        />
        <path
          d="m935.77 466.32 27.44-42.22v27.8l-27.44 14.42zM918.81 414.13l44.4 9.97-22.2 11.67-22.2-21.64z"
          className="cls-prop21"
        />
        <path
          d="m1367.5 764.71 8.76 17.74 19.58 2.85-14.17 13.81 3.34 19.5-17.51-9.21-17.51 9.21 3.34-19.5-14.17-13.81 19.58-2.85 8.76-17.74z"
          className="cls-prop23"
        />
        <path
          d="m1367.5 791.66-8.76-9.21 8.76-17.74v26.95zM1395.84 785.3l-28.34 6.36 8.76-9.21 19.58 2.85zM1385.01 818.61l-17.51-26.95 14.17 7.45 3.34 19.5zM1349.99 818.61l17.51-26.95v17.74l-17.51 9.21zM1339.16 785.3l28.34 6.36-14.17 7.45-14.17-13.81z"
          className="cls-prop21"
        />
        <path
          d="m644.94 772.16 8.76 17.74 19.58 2.85-14.17 13.81 3.35 19.5-17.52-9.21-17.51 9.21 3.34-19.5-14.16-13.81 19.58-2.85 8.75-17.74z"
          className="cls-prop23"
        />
        <path
          d="m644.94 799.11-8.75-9.21 8.75-17.74v26.95z"
          className="cls-prop21"
        />
        <path
          d="m673.28 792.75-28.34 6.36 8.76-9.21 19.58 2.85z"
          className="cls-prop21"
        />
        <path
          d="m662.46 826.06-17.52-26.95 14.17 7.45 3.35 19.5zM627.43 826.06l17.51-26.95v17.74l-17.51 9.21z"
          className="cls-prop21"
        />
        <path
          d="m616.61 792.75 28.33 6.36-14.17 7.45-14.16-13.81z"
          className="cls-prop21"
        />
        <path
          d="m791.639 509.177 2-.006.436 156.19-2 .005zM961.964 242.622l2-.006.436 156.19-2 .005zM1187.662 442.871l2-.006.436 156.19-2 .005zM1366.234 630.162l2-.006.436 156.19-2 .005zM643.697 617.045l2-.007.698 190.349-2 .007z"
          className="cls-prop23"
        />
        {children}
      </g>
    </svg>
  );
}
